import React, { useEffect, useState, useCallback, Fragment } from 'react';
import { Upload, message } from 'antd';
import { addGarageDetailsImageById  } from '../../GarageEditPage/actions';
import config from '$config';

 
export default function AddImage({garageId, cellValue, handleInputChange}){

  const [imageName, setImageName] = useState(cellValue.imageName || "");

  const uploadAction = (ev) => {
    var form = new window.FormData();
    form.append('file', ev);
    
    return addGarageDetailsImageById(garageId, form)
    .then( res => {
      handleInputChange(res.path);
      setImageName(res.path);
    })      
  }
  
  return (
    <Upload
      name="file"
      listType="picture-card"
      className="avatar-uploader"
      showUploadList={false}
      action={uploadAction}
      >
      {imageName ? <img src={`${config.landingUrl}garages/${config.env}/${garageId}/${imageName}/jpeg`} alt="file" style={{ width: '100%' }} /> : <div className="ant-upload-text">Upload</div>}
    </Upload>
  );

}
